export enum ControlTypeEnum {
    Elimination = 0,
    Substitution = 1,
    Engineering = 2,
    Administrative = 3,
    PPE = 4
}
